// @ts-nocheck

import styled, { css } from 'styled-components';

import { Target } from '../../client';
import CrossCloseButton from '../../modules/grids/components/buttons/CrossCloseButton';
import { ZIndices } from '../../styled-components/dark/common';
import { Button } from '../../styled-components/shared';

export const CloseIcon = styled(CrossCloseButton)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  margin: 0;

  ${Target.__MOBILE__
    ? css`
        width: 15px;
        height: 15px;
      `
    : css`
        width: 20px;
        height: 20px;
        &:hover {
          color: #fff;
        }
      `}
`;

export const StyledExitButton = styled(Button)`
  && {
    background-color: ${({ theme }) => theme.common.colors.primary};
    height: 2.5em;
    width: 2.5em;
    border-radius: 50%;
    padding: 0;

    box-shadow: none;
    pointer-events: all;
    position: absolute;
    right: var(--ExitButton-right, 0);
    top: var(--ExitButton-top, 0);

    transform: ${({ $positionInside }) =>
      $positionInside ? 'translate3d(-0.6em, 0.6em, 0)' : 'translate3d(50%, -50%, 0)'};

    transition: background-color 0.1s ease-out;

    ${Target.__MOBILE__
      ? css`
          height: 2.5em;
          width: 2.5em;
        `
      : css`
          height: 3.5em;
          width: 3.5em;

          &:hover {
            background: #000;
          }
        `}

    ${({ theme, $zIndex }) => css`
      background-color: ${theme.grids.colors.black};
      z-index: ${$zIndex ?? ZIndices.navBar};
    `}
  }
`;
